export const GRANT_LOAD_ACTION = 'GRANT_LOAD_ACTION';
export const grantLoadAction = data => ({
  type: GRANT_LOAD_ACTION,
  payload: { data },
});
